import React from 'react';
import { Dialog } from '../../molecules/Dialog';
import { DialogActions, Box } from '@mui/material';
import Text from '../../atoms/Text';
import ActionButton from '../../molecules/Buttons/ActionButton';

export type ConfirmProps = {
  onCancel?: () => void;
  cancelLabel: string;
  onConfirm?: () => void;
  confirmLabel: string;
  title: string;
  description?: string;
};

export default function ConfirmDialog({
  cancelLabel,
  onCancel,
  confirmLabel,
  onConfirm,
  title,
  description,
}: ConfirmProps) {
  const handleCancel = () => onCancel?.();
  const handleConfirm = () => onConfirm?.();

  return (
    <Dialog onClose={handleCancel} title={title} open>
      {description && (
        <Box sx={{ mt: 2 }}>{description && <Text>{description}</Text>}</Box>
      )}
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleConfirm();
        }}
      >
        {/* keep actions outside the Stack spacing */}
        <DialogActions sx={{ mt: 2, px: 0 }}>
          <ActionButton
            variant="outlined"
            onClick={handleCancel}
            label={cancelLabel}
          />
          <ActionButton
            variant="contained"
            type="submit"
            label={confirmLabel}
            disableElevation
          />
        </DialogActions>
      </Box>
    </Dialog>
  );
}
